export enum ChatEventsNameE {
  JOIN_ROOMS = 'join-rooms',
  CONTACT_REMOVED = 'contact-removed',
  CONTACT_UPDATED = 'contact-updated',
  CONTACT_CHANGED = 'contact-changed',
  CLOSE_CHAT = 'close-chat',
  CHAT_DATA = 'chat-data',
  LEAVE_ROOMS = 'leave-rooms',
  LOGIN_USER = 'login-user',
  MESSAGE_STATUS = 'message-status',
  MESSAGE_TRANSCRIPTION = 'message-transcription',
  MESSAGE = 'message',
  MESSAGE_UPDATED = 'message-updated',
  NEW_CONTACT_CREATED = 'new-contact-created',
  NEW_CHAT = 'new-chat',
  NEW_MAIL = 'new-mail',
  NEW_USER_CREATED = 'new-user-created',
  TRANSFER_CHAT = 'transfer-chat',
  USER_REMOVED = 'user-removed',
  USER_UPDATED = 'user-updated',
  NEW_INTERNAL_CHAT = 'new-internal-chat',
  LOYALTY_CREATED = 'loyalty-created',
  LOYALTY_REMOVED = 'loyalty-removed',
  LOAD_CHAT_DATA = 'load-chat-data',
  WIDGET_PING = 'widget-ping',
  USER_TYPING = 'user-typing',
  USER_STATUS = 'user-status',
  CHAT_STATUS = 'chat-status',
  CHANNEL_STATUS = 'channel-status',
  NEW_CHAT_STEP = 'new-chat-step',
  CREATE_GROUP_STEP_CALL_INITIATED = 'create-chat-step-call-initiated',
  PAUSE_STARTED = 'pause-started',
  PAUSE_ENDED = 'pause-ended',
  UPDATE_TASK = 'update-task',
  PABX_CALL_ATTENDED = 'pabx-call_attended',
  SUPPORT_TICKET_ALERT = 'support-ticket-alert',
  WHATSAPP_CONNECTION = 'whatsapp-connection',
}
